import React, { useCallback, useContext } from 'react';

import { DefaultNurseOperationDetailContext } from '../../default-nurse-operation-detail.context';
import DefaultNurseOperationDetailForm from '../Form';

export default function EditDialog() {
  const { editDialogOpened, setEditDialogOpened, selectedData, reload } = useContext(DefaultNurseOperationDetailContext);
  const closeDialog = useCallback(
    (success: boolean) => {
      if (success) {
        reload();
      }
      setEditDialogOpened(false);
    },
    [reload, setEditDialogOpened]
  );

  return <DefaultNurseOperationDetailForm open={editDialogOpened} onClose={closeDialog} data={selectedData} />;
}
